import { render } from "./ReleaseAccessCreate.vue?vue&type=template&id=3d5695b8"
import script from "./ReleaseAccessCreate.vue?vue&type=script&lang=js"
export * from "./ReleaseAccessCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__